import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Mail, Facebook } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_small-biz-insurance/artifacts/mi1lmpqz_Screenshot%202026-02-26%20083114.png";

const quickLinks = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Reviews", path: "/reviews" },
  { label: "Resources", path: "/resources" },
  { label: "Careers", path: "/careers" },
  { label: "Contact", path: "/contact" },
];

const serviceLinks = ["Dental Insurance", "Vision Insurance", "Supplemental Insurance", "Group Life & Disability"];

// Sub-components
const FooterBrand = () => (
  <div className="space-y-4">
    <img src={LOGO_URL} alt="Viall Business Solutions" className="h-16 w-auto object-contain brightness-0 invert" />
    <p className="text-gray-300 text-sm leading-relaxed">Helping small businesses offer better employee benefits. Affordable, simple, and personal.</p>
    <p className="text-[#2EC4C4] text-xs font-semibold uppercase tracking-wider">Enhance Your Benefits. Keep Your Bottom Line.</p>
    <a href="https://www.facebook.com/profile.php?id=100089756735427" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="w-9 h-9 bg-[#2EC4C4] rounded-full flex items-center justify-center hover:bg-[#25A0A0] transition-colors" aria-label="Facebook">
      <Facebook size={18} />
    </a>
  </div>
);

const FooterLinks = () => (
  <div>
    <h4 className="font-semibold text-white mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>Quick Links</h4>
    <ul className="space-y-2">
      {quickLinks.map((link) => (
        <li key={link.path}>
          <Link to={link.path} data-testid={`footer-link-${link.label.toLowerCase().replace(" ", "-")}`} className="text-gray-300 hover:text-[#2EC4C4] text-sm transition-colors">
            {link.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

const FooterServices = () => (
  <div>
    <h4 className="font-semibold text-white mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>Services</h4>
    <ul className="space-y-2">
      {serviceLinks.map((s) => (
        <li key={s}>
          <Link to="/services" className="text-gray-300 hover:text-[#2EC4C4] text-sm transition-colors">{s}</Link>
        </li>
      ))}
    </ul>
  </div>
);

const FooterContact = () => (
  <div>
    <h4 className="font-semibold text-white mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>Contact Us</h4>
    <div className="space-y-3">
      <div className="flex items-start space-x-3">
        <MapPin size={16} className="text-[#2EC4C4] mt-0.5 flex-shrink-0" />
        <p className="text-gray-300 text-sm">315 Main St S Suite 308<br />Minot, ND 58701</p>
      </div>
      <div className="flex items-center space-x-3">
        <Phone size={16} className="text-[#2EC4C4] flex-shrink-0" />
        <a href="tel:+17017217993" data-testid="footer-phone" className="text-gray-300 hover:text-[#2EC4C4] text-sm transition-colors">(701) 721-7993</a>
      </div>
      <div className="flex items-center space-x-3">
        <Mail size={16} className="text-[#2EC4C4] flex-shrink-0" />
        <a href="mailto:office@viallbusiness.com" data-testid="footer-email" className="text-gray-300 hover:text-[#2EC4C4] text-sm transition-colors">office@viallbusiness.com</a>
      </div>
      <div className="flex items-start space-x-3">
        <Clock size={16} className="text-[#2EC4C4] mt-0.5 flex-shrink-0" />
        <p className="text-gray-300 text-sm">Mon to Fri: 9AM to 5PM</p>
      </div>
    </div>
  </div>
);

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#1A2744] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <FooterBrand />
          <FooterLinks />
          <FooterServices />
          <FooterContact />
        </div>
        <div className="border-t border-gray-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center space-y-3 md:space-y-0">
          <p className="text-gray-400 text-sm">© {new Date().getFullYear()} Viall Business Solutions. All rights reserved.</p>
          <p className="text-gray-500 text-xs text-center md:text-right">Small Business Insurance Minot ND | Employee Benefits North Dakota | Group Dental &amp; Vision Insurance</p>
        </div>
      </div>
    </footer>
  );
}
